import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { ReservationPriority } from './reservation-priority.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
@Injectable()
export class ReservationPriorityService extends AbstractEntityService {

    protected resourceUrl = 'api/reservation-priorities';
    private resourceSearchUrl = 'api/_search/reservation-priorities';
    protected resourceCountUrl = 'api/_search/count/reservation-priorities';

    constructor(protected http: HttpClient) { super(http); }

    create(reservationPriority: ReservationPriority): Observable<ReservationPriority> {
        let copy: ReservationPriority = Object.assign({}, reservationPriority);
        return this.http.post<ReservationPriority>(this.resourceUrl, copy).map((res: ReservationPriority) => {
            return res;
        });
    }

    update(reservationPriority: ReservationPriority): Observable<ReservationPriority> {
        let copy: ReservationPriority = Object.assign({}, reservationPriority);
        return this.http.put<ReservationPriority>(this.resourceUrl, copy).map((res: ReservationPriority) => {
            return res;
        });
    }

    find(id: number): Observable<ReservationPriority> {
        return this.http.get<ReservationPriority>(`${this.resourceUrl}/${id}`).map((res: ReservationPriority) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<ReservationPriority[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<ReservationPriority[]>>(this.resourceUrl, options)
            ;
    }

    search(req?: any): Observable<HttpResponse<ReservationPriority[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<ReservationPriority[]>>(this.resourceSearchUrl, options);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-priority/reservation-priority.service.ts